import React from "react";
import Card from "../../components/page/Card";
import CategoriasDataTable from "./Tipos/CategoriasDataTable";
import TiposModal from "./Tipos/TiposModal";
import CommonSwal from "../../components/Swal/commonSwal";
import OptionsSwal from "../../components/Swal/optionsSwal";
import EditarTipoModal from "./Tipos/EditarTipoModal";
import useApi from "../../hooks/useApi";
import TiposApiClient from "../../api/tipos";
import Validation from "../../helpers/Validation";
import ErrorSwal from "../../components/Swal/errorSwal";

function Tipos() {
  const [categorias, setCategorias] = React.useState([]);
  const [tipos, setTipos] = React.useState([]);
  const [tiposModal, setTiposModal] = React.useState(false);
  const [editarTipoModal, setEditarTipoModal] = React.useState(false);
  const [values, setValues] = React.useState({});
  const [currentCategoria, setCurrentCategoria] = React.useState("");

  const { request: getCategorias, data: categoriasResponse } = useApi(
    TiposApiClient.listCategorias
  );
  const { request: getTipos, data: tiposResponse } = useApi(
    TiposApiClient.listTipos
  );
  const postTiposApi = useApi(TiposApiClient.postTipos);
  const putTiposApi = useApi(TiposApiClient.putTipos);
  const deleteTiposApi = useApi(TiposApiClient.deleteTipos);

  //Busca dados dos cards ao renderizar tela
  React.useEffect(() => {
    getCategorias();
  }, [getCategorias]);

  //Define o retorno da api no valor do estado
  React.useEffect(() => {
    if (categoriasResponse) setCategorias(categoriasResponse);
  }, [categoriasResponse]);

  //Define o retorno da api no valor do estado
  React.useEffect(() => {
    if (tiposResponse) setTipos(tiposResponse);
  }, [tiposResponse]);

  const togTiposModal = async (categoria) => {
    await getTipos({ categoria: categoria });
    setCurrentCategoria(categoria);
    setTiposModal(true);
  };

  const togNovoTipoModal = () => {
    setValues({});
    setEditarTipoModal(true);
  };

  const togEditarTipoModal = (tipo) => {
    setValues(tipo);
    setEditarTipoModal(true);
  };

  const deletartipo = async (uid) => {
    OptionsSwal({
      title: "Você tem certeza que deseja excluir este tipo?",
      icon: "warning",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const response = await deleteTiposApi.request(uid);
        if (!response) return;
        CommonSwal({
          title: "Tipo excluído com sucesso!",
          icon: "success",
        }).then(async (result) => {
          if (result.isConfirmed || result.isDismissed) {
            getCategorias();
            const response = await getTipos({ categoria: currentCategoria });
            if (response && response.length === 0) setTiposModal(false);
          }
        });
      }
    });
  };

  const salvaTipo = async () => {
    const formData = new FormData();
    formData.append("categoria", values.categoria);
    formData.append("chave", values.chave);
    formData.append("valor", values.valor);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await putTiposApi.request(values?.uid, formData);
    if (response) {
      CommonSwal({
        title: "Tipo salvo com sucesso!",
        icon: "success",
      }).then((result) => {
        if (result.isConfirmed || result.isDismissed) {
          getTipos({ categoria: currentCategoria });
          getCategorias();
          setEditarTipoModal(false);
        }
      });
    }
  };

  const novoTipo = async () => {
    const formData = new FormData();
    formData.append("categoria", values.categoria);
    formData.append("chave", values.chave);
    formData.append("valor", values.valor);

    if (Validation.verificarForm(formData))
      return ErrorSwal({
        text: "Favor preencher todos os dados obrigatórios.",
      });

    const response = await postTiposApi.request(formData);
    if (response) {
      CommonSwal({
        title: "Tipo salvo com sucesso!",
        icon: "success",
      }).then((result) => {
        if (result.isConfirmed || result.isDismissed) {
          getCategorias();
          setEditarTipoModal(false);
        }
      });
    }
  };

  return (
    <Card>
      <CategoriasDataTable
        linhas={categorias}
        togTiposModal={togTiposModal}
        togNovoTipoModal={togNovoTipoModal}
      />
      <TiposModal
        isOpen={tiposModal}
        setIsOpen={setTiposModal}
        tipos={tipos}
        togEditarTipoModal={togEditarTipoModal}
        deletartipo={deletartipo}
      />
      <EditarTipoModal
        valuesHook={{ values, setValues }}
        salvaTipo={salvaTipo}
        isOpen={editarTipoModal}
        setIsOpen={setEditarTipoModal}
        novoTipo={novoTipo}
      />
    </Card>
  );
}

export default Tipos;
